import LoadingSkeletonContainer from 'ComponentLibrary/src/atoms/LoadingSkeleton/LoadingSkeletonContainer'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { Box, Stack } from '@mui/material'
import { LoadingSkeleton } from 'ComponentLibrary/src/atoms/LoadingSkeleton'

export function TaskCommentsLoader() {
    return (
        <Stack alignItems="center" width="100%" height="100%" boxSizing="border-box" justifyContent="space-between">
            <Stack
                gap={tokens.SizingSpacing150}
                direction="row"
                width="100%"
                padding={`${tokens.SizingSpacing200} ${tokens.SizingSpacing300}`}
                boxSizing="border-box"
            >
                <LoadingSkeleton width="60%" count={1} height="40px" sx={{ transform: 'unset' }} />
                <LoadingSkeleton width="30%" count={1} height="40px" sx={{ transform: 'unset' }} />
                <LoadingSkeleton width="10%" count={1} height="40px" sx={{ transform: 'unset' }} />
            </Stack>
            <Stack direction="column" width="100%">
                <Box height="400px" width="100%">
                    <LoadingSkeletonContainer loadersPattern={[{ count: 2, height: '180px' }]} gap={tokens.SizingSpacing150} />
                </Box>
                <Box height="134px" width="100%">
                    <LoadingSkeletonContainer loadersPattern={[{ count: 1, height: '100px' }]} justifyContent="center" />
                </Box>
            </Stack>
        </Stack>
    )
}
